// Student endpoints
export const student = "student/";
export const RegisterStudent = "student/register";
export const UpdateStudent = "student/update";
export const Update = "student/update"; // Alias for UpdateStudent
export const StudentLogin = "student/login";
export const student_Login = "student/login"; // Alias for StudentLogin
export const StudentStats = "student/stats";
export const StudentQualification = "student/qualification";

// Course endpoints
export const Course = "course/";
export const AddCourse = "course/addcourse";
export const Add_Course = "course/addcourse"; // Alias for AddCourse
export const UpdateCourse = "course/update";
export const Update_Course = "course/update"; // Alias for UpdateCourse

// Chapter endpoints
export const Chapter = "chapter/";
export const AddChapter = "chapter/addchapter";
export const UpdateChapter = "chapter/update";
